export const copyTextToClipboard = async (value: string): Promise<void> => {
  if (typeof window === 'undefined') {
    throw new Error('Clipboard copy is only available in a browser environment');
  }

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch (error) {
      if (!window.isSecureContext) {
        const message = 'Clipboard API works only on localhost or HTTPS';
        throw new Error(message, { cause: error });
      }
    }
  }

  if (!document.body) {
    throw new Error('Failed to copy to clipboard');
  }

  const textArea = document.createElement('textarea');
  textArea.value = value;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  textArea.style.left = '-9999px';
  textArea.style.top = '-9999px';
  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, value.length);

  try {
    const success = document.execCommand('copy');
    if (!success) {
      throw new Error('Clipboard copy was denied by the browser');
    }
  } finally {
    document.body.removeChild(textArea);
  }
};
